import gql from 'graphql-tag'

export default gql`
    mutation cdrEnergy($adminUserID: String, $insightType: String) {
        cdrEnergy(adminUserID: $adminUserID, insightType: $insightType) {
            InsightID
        }
    }
`
